import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 * A video.js Component for the 'previous item' button
 * @param player {Object} A VideoJS player instance.
 * @param options {Object} An object containing options to be passed to this component.
 */
export default class PlaylistForwardButton extends Button {
  constructor(player, options) {
    super(player, options);

    this.addClass('vjs-menu-button');
    this.addClass('vjs-playlist-next-button');
    this.addClass('vjs-icon-next-item');
    this.controlText(player.localize('Next Video'));
  }

  handleClick() {
    try {
      this.player_.playlist.next();
    } catch (e) {
      videojs.log.error(e);
    }
  }
}
